/**
 * Datos de los widgets «Productos» y «Contactos» del dashboard
 * (GET /api/trade-insights): una sola llamada aunque haya varios widgets, y se reusa
 * 5 minutos («Actualizar» de cualquiera la pide de nuevo). Las filas llegan como
 * tuplas con un diccionario de ids; acá se arman objetos:
 *   { s: fuente, k: lado, m: "YYYY-MM", p: producto, b: comprador, v: vendedor,
 *     u: unidad, q: cantidad, o: [operaciones], c: moneda, a: monto }
 */
import { wencesApi } from "@/api/wencesApi";

const TTL_MS = 5 * 60 * 1000;
let pending = null;
let at = 0;
let forceNext = false;

function decode(raw) {
  const ids = raw.ids || [];
  const id = (i) => (i >= 0 ? ids[i] : null);
  const rows = (raw.rows || []).map((r) => ({
    s: r[0],
    k: r[1],
    m: r[2],
    p: id(r[3]),
    b: id(r[4]),
    v: id(r[5]),
    u: id(r[6]),
    q: r[7],
    o: r[8],
    c: id(r[9]),
    a: r[10],
  }));
  return { ...raw, rows };
}

/** «Actualizar»: el próximo pedido va al back sin caché (allá también se guarda 5 min). */
export function invalidateTradeInsights() {
  pending = null;
  forceNext = true;
}

export function loadTradeInsights(force = false) {
  if (forceNext) {
    force = true;
    forceNext = false;
  }
  if (!force && pending && Date.now() - at < TTL_MS) return pending;
  at = Date.now();
  pending = wencesApi
    .get("/api/trade-insights", { params: force ? { fresh: 1, _: at } : { _: at } })
    .then(({ data }) => decode((data && data.data) || {}))
    .catch((e) => {
      pending = null;
      throw e;
    });
  return pending;
}
